// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Q3Pp","right":"styles_right__2uXbx"};